import { OTPVerificationAction } from '../actions/OTPVerificationAction'
import { SequenceManagerAction } from "../actions/SequenceManagerAction";

const initState = {
    requestBody: {
        sectionId: "OTPVerification",
        steps: [
            {
                sequence: "0",
                stepId: "OTPVerification",
                offerContainerId: "",
                fields: [
                    {
                        name: "OTP",
                        value: ""
                    }
                ]
            }
        ]
    },
    initiateOTPResponse: {

    },
    validateOTPResponse: {

    },
    rSendOTPResponse: {

    },
  }
  
  const OTPVerificationReducer = (state: any = initState, action: any) => {
    const { type } = action;
    const { payload } = action;
    var OTPVerificationValue = { ...state.requestBody.steps };
  
    switch (type) {
      case OTPVerificationAction.OTP_VERIFICATION_VALUE:
        OTPVerificationValue[0].fields[0].value = payload.otp;
        OTPVerificationValue[0].offerContainerId = payload.offerContainerId;
        return state;

        case OTPVerificationAction.VERIFICATION_OTP_INITIATE_SUCCESS:
            return { ...state, initiateOTPResponse: payload };

        case OTPVerificationAction.VERIFICATION_OTP_VALIDATE_SUCCESS:
            return { ...state, validateOTPResponse: payload };

        case OTPVerificationAction.VERIFICATION_OTP_RSEND_SUCCESS:
            return { ...state, rSendOTPResponse: payload };
  
        case SequenceManagerAction.DISPLAY_SECTION:
            return { ...state, initiateOTPResponse: {} };

      case SequenceManagerAction.GET_CHECKOUT_SUCCESS:
        let section = payload.sections.filter((section: any) => {
          return (section.sectionId === 'OTPVerification')
        });
        if (section.length > 0) {
          let numberTypeValue = section[0].steps[0].fields[0];
          OTPVerificationValue[0].offerContainerId = section[0].steps[0].offerContainerId;
          OTPVerificationValue[0].fields[0].value = numberTypeValue ? numberTypeValue.value : "";
        }
        return state;
  
      default:
        return state;
    }
  }
  
  export default OTPVerificationReducer;